import { render, staticRenderFns } from "./historique.vue?vue&type=template&id=720401be&scoped=true&"
import script from "./historique.vue?vue&type=script&lang=ts&"
export * from "./historique.vue?vue&type=script&lang=ts&"
import style0 from "./historique.vue?vue&type=style&index=0&id=720401be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720401be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
